export class DebtorManagement {
  idDebtorTable: number
  idDebtor: string
  debtorName: string
  debtorPhone: string
  debtorAddress: string
  debtorMail: string
  debtorContactName: string
  debtorContacPhone: string
  totalValue: number
  portfolioBalance: number
  modificationUser: number
}
